export class HeaderMenu {

    public $dropdown: JQuery<HTMLDivElement>;

    public $hamburger: JQuery<HTMLDivElement>;
    public $menulist: JQuery<HTMLDivElement>;

    constructor() {
        this.$dropdown = $('.header__menu__dropdown--top-level');
        this.$hamburger = $('.header__menu__hamburger');
        this.$menulist = $('.header__menu__list');

        this.$dropdown.on({
            mouseenter: function() {
                $( this ).removeClass( "collapsed" );
            }, mouseleave: function() {
                $( this ).addClass( "collapsed" );
            }
        });

        this.$hamburger.on('click', () => this.menuToggle());
    }

    public menuToggle(): void {
        this.$menulist.toggleClass('expanded');
    }
}